import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme={'light'}
      className="toaster group"
      toastOptions={{
        classNames: {
          error: '!text-destructive',
        },
      }}
      position="top-center"
      duration={3000}
      {...props}
    />
  );
};

export { Toaster };
